import {defineStore} from 'pinia'
import _ from "lodash";
import {getFirstPage, onFilter, onPage, onRowsUpdate, onSearch, onSort} from "@/stores/_helpers.js";
import {useRxSWINStore} from "@/stores/rxSWIN.js";

export const useRxSWINSearchPageStore = defineStore('rxSWINSearchPage', {
    state: () => ({
        data: undefined,
        totalRecords: 0,
        params: {
            with_user_assets: 1,
            per_page: 20,
            page: 1,
            fields: {rx_swins: ['id', 'identifier', 'regulation_id', 'vehicle_manufacturer_id']},
            include: [
                'regulation',
                'vehicleManufacturer',
                'mappingsCount',
            ],
            filter: {
                search: null
            }
        },
        pages: [
            10,
            20,
            50,
            100,
        ],
        searched : false
    }),
    getters: {
        getRxSWINs: (state) => {
            return state.data?.data;
        },
        getFirstPage: (state) => {
            return getFirstPage(state.params)
        }
    },
    actions: {
        onPage($event) {
            onPage($event, this.params);
            this.loadData();
        },
        onSort($event) {
            onSort($event, this.params);
            this.loadData();
        },
        onRowsUpdate(rowCount) {
            onRowsUpdate(rowCount, this.params);
        },
        onFilter($event) {
            onFilter($event, this.params);
            this.loadData();
        },
        onSearch: _.debounce(function () {
                onSearch(this.params)
                this.loadData();
            },
            500
        ),
        async loadData() {
            if (!this.params.filter.search ||
                this.params.filter.search.length === 0) {
                this.clearSearched()
                return;
            }
            const rxSWINStore = useRxSWINStore();
            this.loading = true;
            this.data = await rxSWINStore.indexRxSWINs(this.params)
            this.totalRecords = this.data.total;
            this.loading = false;
            this.searched = true;
        },
        clearSearched() {
            this.searched = false;
            this.data = null;
        }
    },
    mounted() {
        // this.loadData();
    }
});
